@for (tag of tags(); track $index) {
  <span class="tag">
    <span class="tag-name">{{ tag }}</span>
    @if (removable()) {
      <span (click)="removeTag($index)" class="icon icon-minus-box"></span>
    }
  </span>
}
